import React from "react";

const NotFound=()=>
{
    return "Error 404";
}

export default NotFound